<template>
    <div>
        <Header title="精选推荐" v-if="!isWx" />
        <div class="listBox" v-if="!(lists.length > 0)">
            <waterfall 
                :col='col' 
                :data="lists"
                :width="itemWidth" 
                :gutterWidth="gutterWidth"
                @loadmore="loadmore"  
            >
                <template>
                    <div v-for="item in lists" :key="item.id">
                        <WaterfallList :data="item" />
                    </div>
                </template>
            </waterfall>
        </div>
        <EmptyList v-if="isEmpty" />
    </div>
</template>


<script>
import { Header, WaterfallList, EmptyList } from '@/components'
import { getCommendPage } from '@/request/api'
import { checkWx } from '@/pages/index/custom'

export default {
    components: {
        Header,
        WaterfallList,
        EmptyList
    },
    data() {
        return {
            col: 2, // 瀑布流列数
            page: 1,  // 瀑布流分页
            lists: [], // 列表
            isEmpty: false,
            isWx: true
        }
    },
    methods: {
        // 获取最新晒照
        initList() {
            getCommendPage({
                page: this.page,
                pcount: 10
            }).then( res => {
                let {posts, error_code} = res;
                if(error_code === 0) {
                    this.lists = this.lists.concat(posts);
                    this.page++;
                    if(this.lists.length <= 0 || !this.isEmpty) {
                        this.isEmpty = true
                    } else {
                        this.isEmpty = false;
                    }
                }
            }).catch( error => {
                console.log(error)
            })
        },
        loadmore(index){
            this.initList()
        }
    },
    computed:{
        itemWidth(){  
            return Math.floor((document.documentElement.clientWidth-55)/2)
        },
        gutterWidth(){
            return 15
        }
    },
    created() {
        this.isWx = checkWx()
        this.initList()
    }
}
</script>


<style lang="less" scoped>
    .listBox {
        padding-top: 3.75rem;
    }
</style>